import React from 'react';
import ReactSelect from 'react-select';

var CurrentUser = require("lib/account/CurrentUser");
var AccountPlans = require("lib/account/AccountPlans");

var Modal = require("components/utility/AltModal");

require("appdev/wizards/upgrade_token_form_modal.scss");

class UpgradeTokenFormModal extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        this.state = {
            tokenStartDate: '',
            tokenPlanType: {},
            tokenType: {},
            licenseClasses: 0
        };
    }

    /////// Helpers ///////

    // returns all plan type options
    getPlanTypeOptions() {
        return _.map(AccountPlans.PAID_PLANS, p => { return { value: p, label: p } })
    }

    getTokenTypes() {
        return _.map(TOKEN_TYPES, t => { return { value: t, label: t } })
    }


    // returns non-primary student list options in a format for a select field
    getSecondaryStudentListOptions() {
        var { studentListOptions, primaryStudentLists } = this.state

        if (!_.isEmpty(studentListOptions) && !_.isEmpty(primaryStudentLists)) {
            return _.filter(studentListOptions, (sl) => { return !_.include(primaryStudentLists, sl) })
        }
    }

    getValue(obj, v) {
        return (!_.isEmpty(obj) && _.has(obj, v)) ? obj[v] : null
    }

    // displays alert
    alertUser(alert) {
        window.wrNotifications.triggerDropDownNotification({
            text: alert,
            icon: "exclamation-sign", type: "error"
        }, 3000);
    }

    // validate input
    validateInput() {

        // validate required fields
        var requiredInputs = _.compact(_.map(REQUIRED_FIELDS, f => {
            if (this.state[f] && !_.isEmpty(this.state[f])) {
                return this.state[f]
            }
        }))

        if (_.size(requiredInputs) != _.size(REQUIRED_FIELDS)) {
            return 'Token type, start date, and plan type are required'
        }
    }

    // assign signup_type based on role
    // this must align with the backend, so check the AdminCreator l2e before modifying
    getSignupType() {
        if (this.isTeacher()) { return 'class' }
        if (this.isSchoolAdmin() || this.isDistrictAdmin()) { return 'school' }
    }

    // puts state data in correct format to send with API
    formatPostData() {
        var postData = {
            admin_ids: this.props.adminIDs,
            admin_type: this.getValue(this.state.tokenType, 'value'),
            plan_type: this.getValue(this.state.tokenPlanType, 'value'),
            start_date: this.state.tokenStartDate,
            student_list_count: this.state.licenseClasses,
        };

        // remove all empty key, value pairs
        return _.omit(postData, (value) =>
            value === null ||
            value === 0 ||
            value === '' ||
            value === false ||
            (typeof value === 'object' && Object.keys(value).length === 0) ||
            (Array.isArray(value) && value.length === 0)
        );
    }

    //////// MODAL CONTROLS ACTIONS ///////

    show() {
        this.refs.modal.show();
    }

    //////// STATE MANIPULATORS ////////

    setStudentListOptions() {
        var { schoolOrg } = this.props
        if (!_.isEmpty(schoolOrg) && _.size(schoolOrg.student_lists)) {
            var studentListOptions = _.map(_.where(schoolOrg.student_lists, { inactive: null }), (sl) => {
                return { value: sl.id, label: sl.name }
            })

            this.setState({ studentListOptions })
        }
    }

    ////////////// SUBMIT ACTION //////////////
    handleSubmit(e) {
        $wr.nope(e)

        // validate input
        var validationAlert = this.validateInput()

        if (!_.isEmpty(validationAlert)) {
            return this.alertUser(validationAlert)
        }

        CurrentUser.api().patchSchoolOrg(this.props.schoolOrg.id, { school_org: { upgrade_accounts: { ...this.formatPostData() } } }, $wr.apiHandler((res) => {
            if (res.errors) {
                this.alertUser(res.errors.join(' & '))
            } else {
                window.wrNotifications.triggerDropDownNotification({
                    title: "Admin(s) Upgraded", icon: "ok-sign"
                });

                setTimeout(() => { window.location.reload() }, 1000);
            }
        }));
    }

    ////////////// RENDER METHODS //////////////

    // renders all inputs
    renderInputFields() {
        return (
            <React.Fragment>
                <div className="inputContainer">
                    <div className='inputLabel'>Token Type:</div>
                    <ReactSelect name="role" value={this.state.tokenType}
                        options={this.getTokenTypes()} clearable={false}
                        onChange={(t) => this.setState({ tokenType: t })} />
                </div>
                <div className="inputContainer childInput">
                    <div className='inputLabel'>Start Date:</div>
                    <input data-lpignore="true" type='date' className="form-control" value={this.state.tokenStartDate}
                        onChange={(e) => this.setState({ tokenStartDate: e.target.value })} />
                </div>
                <div className="inputContainer childInput">
                    <div className='inputLabel'>Plan Type:</div>
                    <ReactSelect name="tokenPlanType" value={this.state.tokenPlanType}
                        options={this.getPlanTypeOptions()} onChange={(pt) => this.setState({ tokenPlanType: pt })} />
                </div>
                <div className="inputContainer childInput">
                    <div className='inputLabel'># of License Classes:</div>
                    <input data-lpignore="true" type="number" className="form-control" value={this.state.licenseClasses}
                        onChange={(e) => this.setState({ licenseClasses: e.target.value })} />
                </div>
            </React.Fragment>
        )
    }

    render() {
        return (
            <div className="UpgradeTokenFormModal">
                <Modal headerText="Add Admin" ref="modal">
                    <form onSubmit={this.handleSubmit}>
                        {this.renderInputFields()}
                        <div className='btnContainer'>
                            <button className='btn btn-primary' type='submit'>Submit</button>
                        </div>
                    </form>
                </Modal>
            </div>
        )
    }
};

var TEACHER_TYPE = "teacher"
var HEAD_ADMIN_TYPE = "head-admin"
var SUB_ADMIN_TYPE = "sub-admin"

var TOKEN_TYPES = [TEACHER_TYPE, HEAD_ADMIN_TYPE, SUB_ADMIN_TYPE]

var REQUIRED_FIELDS = ['tokenType', 'tokenPlanType', 'tokenStartDate']

UpgradeTokenFormModal.propTypes = StrictPropTypes({
    schoolOrg: PropTypes.object,
    districtOrg: PropTypes.object,
});

module.exports = UpgradeTokenFormModal;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/UpgradeTokenFormModal.js